// import React from "react";
// import {
//   FiHome,
//   FiPlusCircle,
//    FiLogOut,
// } from "react-icons/fi";
// import { useNavigate, useLocation } from "react-router-dom";



// const Sidebar = () => {
//   const navigate = useNavigate();
//   const location = useLocation();

//   const menuItems = [
//     {
//       label: "Dashboard",
//       icon: <FiHome />,
//       path: "/dashboard",
//     },
//     {
//       label: "Add Requirement",
//       icon: <FiPlusCircle />,
//       path: "/add-requirement",
//     },
//   ];
//     const handleLogout = () => {

//     localStorage.removeItem("token");

//     navigate("/");
//   };


//   return (
//     <aside className="sidebar">
//       <div className="logo-section">

//         {/* LOGO */}
//        <img
//     src="/TT_logo2.png"
//     alt="ReqSphere Logo"
//     className="sidebar-logo"
//   />
//         {/* <h2>ReqSphere</h2>
//         <span>
//           Requirements Platform
//         </span> */}
//       </div>

//       <nav className="nav-links">
//         {menuItems.map((item) => (
//           <button
//             key={item.path}
//             className={`nav-item ${
//               location.pathname === item.path
//                 ? "active"
//                 : ""
//             }`}
//             onClick={() =>
//               navigate(item.path)
//             }
//           >
//             {item.icon}
//             {item.label}
//           </button>
//         ))}
//       </nav>
//         {/* LOGOUT ICON */}
//       <div
//         className="logout-icon"
//         onClick={handleLogout}
//       >
        
//         <FiLogOut />
        
//       </div>
      
//     </aside>
//   );
// };

// export default Sidebar;


import React, { useState, useEffect } from "react";
import {
  FiHome,
  FiPlusCircle,
  FiLogOut,
  FiGitCommit, // Clean developer icon for tracking mappings
} from "react-icons/fi";
import { useNavigate, useLocation } from "react-router-dom";

const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isMilind, setIsMilind] = useState(false);

  // Core menus visible to all authenticated accounts
  const menuItems = [
    {
      label: "Dashboard",
      icon: <FiHome />,
      path: "/dashboard",
    },
    {
      label: "Add Requirement",
      icon: <FiPlusCircle />,
      path: "/add-requirement",
    },

  ];

  // Check user context on mount to toggle administrative visibility
  useEffect(() => {
    try {
      const rawUser = localStorage.getItem("user");
      if (rawUser) {
        const userData = JSON.parse(rawUser);
        // Strict match checking against Milind's exact email address 
        if (userData?.email === "milind@tapasyatech.in") {
          setIsMilind(true);
        }
      }
    } catch (error) {
      console.error("Failed to parse user session context in Sidebar:", error);
    }
  }, []);

  // Flush the entire localStorage cache on sign out to prevent session contamination
  const handleLogout = () => {
    localStorage.clear(); 
    navigate("/");
  };

  return (
    <aside className="sidebar">
      <div className="logo-section">
        {/* LOGO */}
        <img
          src="/TT_logo2.png"
          alt="ReqSphere Logo"
          className="sidebar-logo"
        />
      </div>

      <nav className="nav-links">
        {/* Dynamic Shared Navigation */}
        {menuItems.map((item) => (
          <button
            key={item.path}
            className={`nav-item ${
              location.pathname === item.path ? "active" : ""
            }`}
            onClick={() => navigate(item.path)}
          >
            {item.icon}
            {item.label}
          </button>
        ))}

        {/* CONDITIONALLY RENDERED PROJECT MAPPING (Milind Exclusive) */}
        {isMilind && (
          <button
            className={`nav-item ${
              location.pathname === "/project-mapping" ? "active" : ""
            }`}
            onClick={() => navigate("/project-mapping")}
          >
            <FiGitCommit />
            Project Mapping
          </button>
        )}
      </nav>

      {/* LOGOUT ICON */}
      <div className="logout-icon" onClick={handleLogout} title="Logout">
        <FiLogOut />
      </div>
    </aside>
  );
};

export default Sidebar;